// extracted by mini-css-extract-plugin
module.exports = {"burger":"style_burger__19Qbl","link":"style_link__3gziB","logout":"style_logout__2Uwx1","cart":"style_cart__3PTVi"};